import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "./cx.js";
/**
 * Настрій дня — пʼять намальованих облич без підписів (картка MoodScale).
 *
 * Значення несе **форма рота**: очі однакові, змінюється крива — глибокий
 * вигин униз, дрібний, пряма, дрібна усмішка, повна. Колір `mood-*` лише
 * підсилює, тож у монохромі шкала читається так само. Слово — у
 * `aria-label`, на екрані його немає.
 *
 * Вибране лишає свій колір і піднімається: рамка bold і тінь. Решта
 * біліють, обличчя в них — `ink-3`. Повторний дотик по вибраному знімає
 * вибір: «не позначено» — це просто нічого не натиснути.
 */
export const MOOD_WORDS = ["Важко", "Не дуже", "Рівно", "Добре", "Дуже добре"];
const MOUTHS = [
    "M10 22.5 Q16 15 22 22.5",
    "M10 21.5 Q16 19 22 21.5",
    "M10 21 H22",
    "M10 20.5 Q16 23 22 20.5",
    "M10 19.5 Q16 27 22 19.5",
];
export function MoodFace({ level }) {
    return (_jsxs("svg", { className: "i", "aria-hidden": "true", viewBox: "0 0 32 32", children: [_jsx("circle", { cx: "11.5", cy: "13", r: "1.8", fill: "currentColor" }), _jsx("circle", { cx: "20.5", cy: "13", r: "1.8", fill: "currentColor" }), _jsx("path", { d: MOUTHS[level - 1], stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", fill: "none" })] }));
}
export function MoodScale({ value, onChange, label, words = MOOD_WORDS, disabled }) {
    return (_jsx("div", { role: "radiogroup", "aria-label": label, className: cx("faces", value > 0 && "faces-chosen"), children: [1, 2, 3, 4, 5].map((level) => {
            const on = value === level;
            return (_jsx("button", { type: "button", role: "radio", "aria-checked": on, "aria-label": words[level - 1], disabled: disabled, className: cx("face", `face-${level}`, on && "face-on"), onClick: () => onChange(on ? 0 : level), children: _jsx(MoodFace, { level: level }) }, level));
        }) }));
}
//# sourceMappingURL=Mood.js.map